import React, { Component } from 'react';
import Classname from 'classnames';
import { ReactComponent as Back } from 'Icons/back-bordered.svg';
import { ReactComponent as Forward } from 'Icons/forward-bordered.svg';
import Dropdown from 'Components/Dropdown';

const BID_STATUS_OPTIONS = [
    { name: 'Bidded', value: 'true' },
    { name: 'Non Bidded', value: 'false' },
];

const SEEN_STATUS_OPTIONS = [
    { name: 'Seen', value: 'true' },
    { name: 'Not Seen', value: 'false' },
];

class TransportersTableHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchText : "",
            offset: props.offset || 0,
            bidStatus: "",
            seenStatus: "",
        }
    }
    getFilters = ()=> {
        return {
            search: this.state.searchText,
            offset: this.state.offset,
            limit: 10,
            is_bids: this.state.bidStatus,
            is_seen: this.state.seenStatus,
        };
    }
    clearFilter = ()=> {
        this.props.fetchTransporters(this.getFilters(), true)
    }
    hasActiveFilters = ()=> {
        return !!(this.state.searchText || this.state.bidStatus || this.state.seenStatus);
    }
    clearAllFilters = ()=> {
        this.setState({
            searchText: "",
            bidStatus: "",
            seenStatus: "",
            offset: 0
        }, this.clearFilter)
    }
    applyFilter = ()=> {
        this.props.fetchTransporters(this.getFilters(), true)
    } 
    searchTransporters = (e)=> {
        this.setState({
            searchText: e.target.value,
            offset: 0
        }, this.applyFilter)
    }
    onBidStatusChange = (item)=> {
        this.setState({
            bidStatus: (item && item.value) || '',
            offset: 0
        }, this.applyFilter)
    }
    onSeenStatusChange = (item)=> {
        this.setState({
            seenStatus: (item && item.value) || '',
            offset: 0
        }, this.applyFilter)
    }
    fetchNextTransporters = ()=> {
        this.setState({
            offset: this.state.offset + 10
        }, ()=> {
            this.props.fetchTransporters(this.getFilters());
        });
    }
    fetchPreviousTransporters = ()=> {
        this.setState({
            offset: this.state.offset - 10
        }, ()=> {
            this.props.fetchTransporters(this.getFilters());
        });
    }
    render() {
        const { 
            transportersCount, 
            header,
            searchPlaceholder,
            countText,
            viewMode,
            transporters
        } = this.props;
        const { offset } = this.state;
        return (
            <div className="flex flex-middle flex-between mb-30">
                <div className="fBold fs-22">
                    <span className="mr-10">{header || 'Transporters'}</span>
                    {/* {transportersCount && <span className="fs-12 fSemibold caption-color">{offset + 1} to {(offset + 10)<transportersCount?(offset + 10):transportersCount}</span>} */}
                </div>
                <div className="flex flex-middle">
                    <Dropdown
                        className="mr-15 wt-150"
                        items={BID_STATUS_OPTIONS}
                        selectedItem={BID_STATUS_OPTIONS.find(option => option.value === this.state.bidStatus)}
                        displayKey="name"
                        name="bidStatus"
                        label="All Bid Status"
                        canClear={!!this.state.bidStatus}
                        onSelect={this.onBidStatusChange}
                    />
                    <Dropdown
                        className="mr-15 wt-150"
                        items={SEEN_STATUS_OPTIONS}
                        selectedItem={SEEN_STATUS_OPTIONS.find(option => option.value === this.state.seenStatus)}
                        displayKey="name"
                        name="seenStatus"
                        label="All Seen Status"
                        canClear={!!this.state.seenStatus}
                        onSelect={this.onSeenStatusChange}
                    />
                    <span className="clearable">

                    <input placeholder={searchPlaceholder || "Search Transporters"}
                            type="text" 
                            className="mr-30 wt-200 br-20 ht-40 bg-gray search"
                            value={this.state.searchText}
                            onChange={this.searchTransporters}
                        />
                        
                    {this.state.searchText && this.state.searchText.length > 0 &&   
                        <span 
                            className="clearable__clear" 
                            onClick={() => { 
                                this.setState({ searchText : "" }, 
                                    () => { console.log('searchText', this.state.searchText); this.clearFilter(); }); 
                            }}
                        >&times;</span>}
                    </span>
                    {this.hasActiveFilters() &&
                        <button
                            className="filter-select__clear mr-20 br-20 ht-40 fs-14 fSemibold theme-color curP"
                            onClick={this.clearAllFilters}
                        > Clear Filters </button>
                    }
                    <Back className={Classname("mr-20", {
                        'fill-gray stroke-rect-gray': offset===0,
                        'fill-theme stroke-rect-theme curP': offset > 0
                    })} onClick={this.fetchPreviousTransporters}/>
                    <Forward className={Classname("mr-20", {
                        'fill-gray stroke-rect-gray': transportersCount <= (offset + 10),
                        'fill-theme stroke-rect-theme curP': transportersCount > offset+10
                    })} onClick={this.fetchNextTransporters}/>
                    {/* {transportersCount && <div className="bg-gray ht-25 flex flex-middle pl-15 pr-15 br-5 pr-1 fSemibold fs-16 header-medium-color">{tripsCount} {countText || 'trips added'}</div>} */}
                    {!viewMode && !this.props.editingGroup && 
                        <button className={Classname("ht-25 br-20 white-color bg-theme fs-14 fSemibold pl-15 pr-15 mr-20", {
                            disabled: transporters.length === 0
                        })} onClick={this.props.showCreateGroupPopup}> Create Group </button>
                    }
                    {!viewMode && this.props.editingGroup &&
                        <button className="ht-25 br-20 white-color bg-success fs-14 fSemibold pl-15 pr-15 mr-20" onClick={this.props.editGroup}> Add & Save </button>
                    }
                </div>
            </div>
        )
    }
}

export default TransportersTableHeader;
